import { CampaignFlowType } from './campaign-contract';

const PURCHASE_INTENT_KEY = 'campaign_purchase_intent';
const LOGIN_FLOW_TYPES_KEY = 'campaign_login_flow_types';

const FLOW_TYPES: ReadonlySet<string> = new Set(['PROSPECT', 'MOVEL', 'FIXA']);

export interface CampaignPurchaseIntent {
  productUuid: string;
  variationUuid: string;
  quantity: number;
}

export function writeCampaignPurchaseIntent(intent: CampaignPurchaseIntent): void {
  writeJson(PURCHASE_INTENT_KEY, intent);
}

export function readCampaignPurchaseIntent(): CampaignPurchaseIntent | null {
  const value = readJson(PURCHASE_INTENT_KEY);
  if (!isPurchaseIntent(value)) {
    return null;
  }

  return {
    productUuid: value.productUuid,
    variationUuid: value.variationUuid,
    quantity: value.quantity,
  };
}

export function writeCampaignLoginFlowTypes(flowTypes: CampaignFlowType[]): void {
  writeJson(LOGIN_FLOW_TYPES_KEY, flowTypes);
}

export function clearCampaignLoginFlowTypes(): void {
  try {
    sessionStorage.removeItem(LOGIN_FLOW_TYPES_KEY);
  } catch {
    // ignore
  }
}

export function readCampaignLoginFlowTypes(): CampaignFlowType[] {
  const value = readJson(LOGIN_FLOW_TYPES_KEY);
  if (!Array.isArray(value) || !value.every(isFlowType)) {
    return [];
  }

  return value;
}

function isFlowType(value: unknown): value is CampaignFlowType {
  return typeof value === 'string' && FLOW_TYPES.has(value);
}

function isPurchaseIntent(value: unknown): value is CampaignPurchaseIntent {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return false;
  }

  const intent = value as Record<string, unknown>;
  return (
    typeof intent['productUuid'] === 'string' &&
    typeof intent['variationUuid'] === 'string' &&
    typeof intent['quantity'] === 'number'
  );
}

function writeJson(key: string, value: unknown): void {
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {
    // ignore
  }
}

function readJson(key: string): unknown {
  try {
    const raw = sessionStorage.getItem(key);
    if (!raw) {
      return undefined;
    }
    return JSON.parse(raw);
  } catch {
    return undefined;
  }
}
